import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "me-icon-meta_data",
  "use": "me-icon-meta_data-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"me-icon-meta_data\"><defs><style type=\"text/css\"></style></defs><path d=\"M64 128v768h896V128H64zM0 64h1024v896H0V64z\" p-id=\"2833\" /><path d=\"M64 256h896v64H64zM192 448h640V512h-640zM192 704h640V768h-640z\" p-id=\"2834\" /><path d=\"M320 640H384v192h-64zM640 384h64v192H640z\" p-id=\"2835\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol